import styled from 'styled-components';

const NewsFeedItem = styled.li`
  list-style: none;
  & + & {
    border-top: 1px solid ${({ theme }) => theme.news.palette.bor_lv1_pc};
  }
`;

export default NewsFeedItem;
